<template>
  <div class="company">
    <div class="module-title">
      优质企业
      <div class="more" @click="showMore">更多</div>
    </div>

    <div class="company-container">
      <swiper
        :slides-per-view="2"
        :space-between="20"
        loop
        :autoplay="{
          delay: 3000,
          disableOnInteraction: false
        }"
        >
        <swiper-slide v-for="item in dataList" :key="item.id" @click="getCompanyDetail(item.id)">
          <div class="company-image" :style="{ background: `url(${item.coverUrl})`,backgroundPosition: 'center',backgroundSize: 'cover'}">
            <!-- <img :src="item.coverUrl" :alt="item.corpName"> -->
          </div>
          <div class="company-name">{{item.corpName}}</div>
        </swiper-slide>
      </swiper>
    </div>
    <el-dialog v-model="open" top="100px" lock-scroll custom-class="dialog-style" title="优质企业" width="70%">
      <div class="title">{{company.corpName}}</div>
      <div class="content" v-html="company.content"></div>
    </el-dialog>

    <el-dialog v-model="companyOpen" top="100px" lock-scroll custom-class="dialog-style" title="优质企业" width="80%">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="article-list">
            <div class="article-item" :class="{'active-company': company.id === item.id }" v-for="(item) in tableList" :key="item.id" @click="getDetail(item.id)">
              <div class="article-title" :title="item.corpName">{{ item.corpName }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="title">{{ company.title }}</div>
          <div class="content" v-html="company.content"></div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { getCompanyList, getCompany } from '@/api/article.js'
import { siteCode } from '@/utils/data'
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper'
// Swiper Vue.js 组件
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js'
// 压缩版css总样式
import 'swiper/swiper-bundle.min.css'
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])

// 指数点评列表
const dataList = ref([])
// 参数
const params = reactive({
  pageSize: 6,
  pageNo: 1,
  siteCode: siteCode,
  orderBy: '-sort'
})

// 指数点评弹出层
const open = ref(false)
// 指数点评详细信息
const company = ref({})
// 企业更多
const companyOpen = ref(false)
// 更多企业数据列表
const tableList = ref([])

/** 获取企业列表 */
const getList = () => {
  getCompanyList(params).then(res => {
    dataList.value = res.data
  })
}

/** 获取文章内容 */
const getCompanyDetail = async (id) => {
  await getDetail(id)
  open.value = true
}

/** 获取文章详情 */
const getDetail = async (id) => {
  await getCompany(id).then(res => {
    company.value = res.data
  })
}

/** 展示更多 */
const showMore = () => {
  getCompanyList({
    pageSize: 10,
    pageNo: 1,
    siteCode: siteCode,
    orderBy: '-sort'
  }).then(res => {
    companyOpen.value = true
    tableList.value = [...res.data]
    getDetail(tableList.value[0].id)
  })
}
onMounted(() => {
  getList()
})
</script>

<style lang="scss" scoped>
.company{
  margin-top: 10px;
  .company-container{
    margin: 20px 10px 0 0;
    height: 220px;
    overflow: hidden;
    .company-image{
      height: 180px;
      overflow: hidden;
      cursor: pointer;
    }
    .company-name{
      margin-top: 10px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.active-company{
  background: linear-gradient(270deg, rgba(234,136,74,0.3) 0%, rgba(234,136,74,0.8) 100%) !important;
  border: rgba(234,136,74,0.3) 1px solid;
}
</style>
